// PaymentPlanNewStore
import {defineStore} from 'pinia'
import {ref,computed} from 'vue'; 
import {IClaimList} from '../../lib/Models/ClaimModel';

interface INewPaymentPlanClaims {
    claimId: number,
    charges: number,
    payments: number,
    adjustments: number,
    balance: number,
    isSelected: boolean
};
export const usePaymentPlanNewStore = defineStore('PaymentPlanNewStore', () => {
    const patientBalanceClaims = ref<INewPaymentPlanClaims[]>([]);

    function resetClaims() : void {
        patientBalanceClaims.value = [];
    }  
    function updateClaim(claimId : number, charges : number, payments: number, adjustments: number, balance : number) : void {
        const claim_data : INewPaymentPlanClaims = {claimId: claimId, charges: charges, payments: payments, adjustments: adjustments, balance: balance, isSelected: false};
        const search_index = patientBalanceClaims.value.findIndex(item => item.claimId == claimId);
        if (search_index == -1) {
            patientBalanceClaims.value.push(claim_data);
        }
        else {
            patientBalanceClaims.value[search_index] = claim_data;
        }
    }
    function selectClaim(claimListing : IClaimList) : void {        
        const search_index = patientBalanceClaims.value.findIndex(item => item.claimId == claimListing.claimID);
        if (search_index != -1) {
            patientBalanceClaims.value[search_index].isSelected = claimListing.selected;
        }
    }
    const TotalBalance = computed<number>(()=> {
        const total_balance = patientBalanceClaims.value.map(item => item.balance).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        
        return total_balance ?? 0;
    });
    const TotalBalanceSelected = computed<number>(()=> {
        const total_selected_balance = patientBalanceClaims.value.filter(item => item.isSelected).map(item => item.balance).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        
        return total_selected_balance ?? 0;
    });
    return {resetClaims,updateClaim,selectClaim,patientBalanceClaims,TotalBalance,TotalBalanceSelected};
});


